import React, { useEffect, useRef, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

import {
    CENTRO_POR_DEFECTO,
    GOOGLE_MAPS_LOADER_OPTIONS,
} from "components/utils/mapa/googleMaps";

export default function Mapa(props) {
    const { lat, lng, style } = props;
    const center = {
        lat: lat
            ? typeof lat === "number"
                ? lat
                : parseFloat(lat)
            : CENTRO_POR_DEFECTO.lat,
        lng: lng
            ? typeof lng === "number"
                ? lng
                : parseFloat(lng)
            : CENTRO_POR_DEFECTO.lng,
    };

    const containerStyle = {
        width: "100%",
        height: "100%",
        ...style,
    };

    const mapRef = useRef(null);
    const [markerPos, setMarkerPos] = useState(center);

    const { isLoaded } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);

    useEffect(() => {
        const c = center;
        setMarkerPos(c);
        if (mapRef.current && c && c.lat != null && c.lng != null) {
            try {
                mapRef.current.panTo({ lat: Number(c.lat), lng: Number(c.lng) });
            } catch (e) {
                // ignore pan errors
            }
        }
    }, [center.lat, center.lng]);

    if (!isLoaded) return null;

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={14}
            onLoad={(map) => (mapRef.current = map)}
            onUnmount={() => (mapRef.current = null)}
        >
            <Marker position={markerPos} draggable={false} />
        </GoogleMap>
    );
}
